module.exports = __webpack_public_path__ + "img/phone_blue.7baa2dc2.png";